import React from 'react'
import { Navigate } from 'react-router-dom'
import { isAuthenticated, getUser } from 'services/auth.service'

// Gate a route behind authentication and, optionally, a set of roles.
const ProtectedRoute = ({ children, roles }) => {
  if (!isAuthenticated()) {
    return <Navigate to='/login' replace />
  }
  if (roles && roles.length) {
    const user = getUser()
    if (!user || !roles.includes(user.role)) {
      return <Navigate to='/' replace />
    }
  }
  return children
}

export default ProtectedRoute
